var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowInWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5262 13.5337L11.8798 13.8872L12.2333 13.5337L14.2633 11.5037C14.3581 11.4089 14.5215 11.4089 14.6162 11.5037C14.711 11.5984 14.711 11.7618 14.6162 11.8566L12.0562 14.4166C12.0049 14.4679 11.9443 14.4901 11.8798 14.4901C11.8152 14.4901 11.7546 14.4679 11.7033 14.4166L9.14332 11.8566C9.04858 11.7618 9.04858 11.5984 9.14332 11.5037C9.23806 11.4089 9.40147 11.4089 9.49621 11.5037L11.5262 13.5337Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8799 14.42C11.746 14.42 11.6299 14.3039 11.6299 14.17V4C11.6299 3.86614 11.746 3.75 11.8799 3.75C12.0137 3.75 12.1299 3.86614 12.1299 4V14.17C12.1299 14.3039 12.0137 14.42 11.8799 14.42Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.9302C6.85 20.9302 3.25 17.3302 3.25 12.1802C3.25 11.7702 3.59 11.4302 4 11.4302C4.41 11.4302 4.75 11.7702 4.75 12.1802C4.75 16.4502 7.73 19.4302 12 19.4302C16.27 19.4302 19.25 16.4502 19.25 12.1802C19.25 11.7702 19.59 11.4302 20 11.4302C20.41 11.4302 20.75 11.7702 20.75 12.1802C20.75 17.3302 17.15 20.9302 12 20.9302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowInWhite);
export default __webpack_public_path__ + "static/media/arrow-in-white.60ee9630b4d60b008803e2c5fcd49605.svg";
export { ForwardRef as ReactComponent };